// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2adc5b5","239":"e90a9bb9","732":"e55f5e99"}[chunkId] + ".chunk.js";
};